import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-50005692"), n = n(), _popScopeId(), n;
};

var _hoisted_1 = {
  class: "Ning-detail"
};
var _hoisted_2 = {
  class: "top"
};
var _hoisted_3 = {
  class: "title faffa"
};
var _hoisted_4 = {
  class: "wid"
};

var _hoisted_5 = /*#__PURE__*/_createTextVNode(" 总分： ");

var _hoisted_6 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "time"
  }, null, -1);
});

var _hoisted_7 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("div", {
    class: "line"
  }, null, -1);
});

var _hoisted_8 = {
  class: "detail"
};
var _hoisted_9 = {
  class: "left"
};
var _hoisted_10 = {
  class: "list-box-left"
};
var _hoisted_11 = {
  class: "list-box-right"
};
var _hoisted_12 = {
  class: "right"
};
var _hoisted_13 = {
  class: "list-box-left"
};
var _hoisted_14 = {
  class: "list-box-right"
};
var _hoisted_15 = {
  class: "middle"
};
var _hoisted_16 = {
  class: "title"
};

var _hoisted_17 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "自评详情", -1);
});

var _hoisted_18 = {
  class: "table"
};
var _hoisted_19 = {
  class: "table-first"
};
var _hoisted_20 = {
  class: "table-three"
};
var _hoisted_21 = {
  class: "left"
};
var _hoisted_22 = {
  class: "me"
};

var _hoisted_23 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "tit"
  }, " 自我评价（100字以内）: ", -1);
});

var _hoisted_24 = {
  class: "middle"
};
var _hoisted_25 = {
  class: "title"
};

var _hoisted_26 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, "互评详情", -1);
});

var _hoisted_27 = {
  class: "table"
};
var _hoisted_28 = {
  class: "momo"
};
var _hoisted_29 = {
  class: "nei"
};
var _hoisted_30 = {
  class: "table-first"
};
var _hoisted_31 = {
  class: "table-three"
};
var _hoisted_32 = {
  class: "left"
};
var _hoisted_33 = {
  class: "middle"
};
var _hoisted_34 = {
  class: "title"
};

var _hoisted_35 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", null, " 评议人评议", -1);
});

var _hoisted_36 = {
  class: "table"
};
var _hoisted_37 = {
  class: "table-first"
};
var _hoisted_38 = {
  class: "table-three"
};
var _hoisted_39 = {
  class: "left"
};
var _hoisted_40 = {
  class: "me"
};

var _hoisted_41 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("p", {
    class: "tit"
  }, " 评议人评价（100字以内）: ", -1);
});

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Head = _resolveComponent("Head");

  var _component_el_table_column = _resolveComponent("el-table-column");

  var _component_el_table = _resolveComponent("el-table");

  var _component_el_collapse_item = _resolveComponent("el-collapse-item");

  var _component_el_collapse = _resolveComponent("el-collapse");

  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_Head, {
    title: "民主评议",
    back: true
  }), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", null, _toDisplayString(_ctx.allslist.list.title), 1), _createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("span", null, _toDisplayString(_ctx.allslist.list.score) + "分 ", 1)])]), _hoisted_6, _hoisted_7, _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Data.topData.leftData, function (item) {
    return _openBlock(), _createElementBlock("div", {
      key: item.label,
      class: "list-box"
    }, [_createElementVNode("div", _hoisted_10, _toDisplayString(item.label), 1), _createElementVNode("div", _hoisted_11, [_createElementVNode("span", null, _toDisplayString(item.value || "无"), 1)])]);
  }), 128))]), _createElementVNode("div", _hoisted_12, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Data.topData.rightData, function (item) {
    return _openBlock(), _createElementBlock("div", {
      key: item.label,
      class: "list-box"
    }, [_createElementVNode("div", _hoisted_13, _toDisplayString(item.label), 1), _createElementVNode("div", _hoisted_14, [_createElementVNode("span", null, _toDisplayString(item.value || "无"), 1)])]);
  }), 128))])])]), _createElementVNode("div", _hoisted_15, [_createElementVNode("div", _hoisted_16, [_hoisted_17, _withDirectives(_createElementVNode("p", null, " 总分:" + _toDisplayString(_ctx.allslist.list.selfScore) + "分 ", 513), [[_vShow, _ctx.allslist.list.selfDetail]]), _withDirectives(_createElementVNode("p", null, " 未自评 ", 512), [[_vShow, !_ctx.allslist.list.selfDetail]])]), _withDirectives(_createElementVNode("div", _hoisted_18, [_createVNode(_component_el_table, {
    data: _ctx.allslist.list.selfDetail,
    border: "",
    style: {
      "width": "100%"
    }
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_table_column, {
        label: "考核观测点",
        width: "590",
        align: "center"
      }, {
        default: _withCtx(function (scope) {
          return [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", null, _toDisplayString(scope.row.optionName), 1)])];
        }),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "address",
        label: "评分",
        width: "250",
        align: "center"
      }, {
        default: _withCtx(function (scope) {
          return [_createElementVNode("div", _hoisted_20, [_createElementVNode("div", _hoisted_21, _toDisplayString(scope.row.maxScore) + "分 ", 1)])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["data"]), _createElementVNode("div", _hoisted_22, [_hoisted_23, _createElementVNode("p", null, _toDisplayString(_ctx.allslist.list.selfOpinion), 1)])], 512), [[_vShow, _ctx.allslist.list.selfDetail]])]), _createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_hoisted_26, _withDirectives(_createElementVNode("p", null, " 总分:" + _toDisplayString(_ctx.allslist.list.allpeerScore) + "分 ", 513), [[_vShow, _ctx.allslist.list.peerDetail]]), _withDirectives(_createElementVNode("p", null, " 未互评 ", 512), [[_vShow, !_ctx.allslist.list.peerDetail]])]), _withDirectives(_createElementVNode("div", _hoisted_27, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allslist.list.peerDetail, function (item, index) {
    return _openBlock(), _createBlock(_component_el_collapse, {
      key: index,
      accordion: ""
    }, {
      default: _withCtx(function () {
        return [_createVNode(_component_el_collapse_item, {
          name: "1"
        }, {
          title: _withCtx(function () {
            return [_createElementVNode("div", _hoisted_28, [_createElementVNode("div", null, [_createElementVNode("p", null, _toDisplayString(item.peerName), 1)]), _createElementVNode("div", null, [_createElementVNode("p", null, _toDisplayString(item.sore) + "分", 1)])])];
          }),
          default: _withCtx(function () {
            return [_createElementVNode("div", _hoisted_29, [_createElementVNode("div", null, [_createVNode(_component_el_table, {
              data: item.peerDetail,
              border: "",
              style: {
                "width": "100%"
              },
              "tooltip-effect": "dark"
            }, {
              default: _withCtx(function () {
                return [_createVNode(_component_el_table_column, {
                  label: "考核观测点",
                  width: "590",
                  align: "center",
                  "show-overflow-tooltip": ""
                }, {
                  default: _withCtx(function (scope) {
                    return [_createElementVNode("div", _hoisted_30, [_createElementVNode("div", null, _toDisplayString(scope.row.optionName), 1)])];
                  }),
                  _: 1
                }), _createVNode(_component_el_table_column, {
                  prop: "address",
                  label: "评分",
                  width: "250",
                  align: "center"
                }, {
                  default: _withCtx(function (scope) {
                    return [_createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, _toDisplayString(scope.row.maxScore) + "分 ", 1)])];
                  }),
                  _: 1
                })];
              }),
              _: 2
            }, 1032, ["data"])])])];
          }),
          _: 2
        }, 1024)];
      }),
      _: 2
    }, 1024);
  }), 128))], 512), [[_vShow, _ctx.allslist.list.peerDetail]])]), _createElementVNode("div", _hoisted_33, [_createElementVNode("div", _hoisted_34, [_hoisted_35, _withDirectives(_createElementVNode("p", null, " 总分:" + _toDisplayString(_ctx.allslist.list.secretaryScore) + "分 ", 513), [[_vShow, _ctx.allslist.list.secretaryDetail]]), _withDirectives(_createElementVNode("p", null, " 未评议 ", 512), [[_vShow, !_ctx.allslist.list.secretaryDetail]])]), _withDirectives(_createElementVNode("div", _hoisted_36, [_createVNode(_component_el_table, {
    data: _ctx.allslist.list.secretaryDetail,
    border: "",
    style: {
      "width": "100%"
    }
  }, {
    default: _withCtx(function () {
      return [_createVNode(_component_el_table_column, {
        label: "考核观测点",
        width: "590",
        align: "center",
        "show-overflow-tooltip": ""
      }, {
        default: _withCtx(function (scope) {
          return [_createElementVNode("div", _hoisted_37, [_createElementVNode("div", null, _toDisplayString(scope.row.optionName), 1)])];
        }),
        _: 1
      }), _createVNode(_component_el_table_column, {
        prop: "address",
        label: "评分",
        width: "250",
        align: "center"
      }, {
        default: _withCtx(function (scope) {
          return [_createElementVNode("div", _hoisted_38, [_createElementVNode("div", _hoisted_39, _toDisplayString(scope.row.maxScore) + "分 ", 1)])];
        }),
        _: 1
      })];
    }),
    _: 1
  }, 8, ["data"]), _createElementVNode("div", _hoisted_40, [_hoisted_41, _createElementVNode("p", null, _toDisplayString(_ctx.allslist.list.secretaryOpinion), 1)])], 512), [[_vShow, _ctx.allslist.list.secretaryDetail]])])])], 64);
}